import React from 'react';
import PageLayout from '../../components/layout/PageLayout';
import ComingSoon from '../ComingSoon/ComingSoon';

const Vote: React.FC = () => {
    return <PageLayout header={<></>} body={<ComingSoon></ComingSoon>} />;
};

export default Vote;
